import $ from "jquery"
import './scss/public.scss'
import "bootstrap/dist/js/bootstrap.bundle"

jQuery(function ($) {
    // Check if there's a hash in the URL
    const hash = window.location.hash;
    if (!hash) return;

    // Wait for DOM to be fully ready
    $(document).ready(function() {
        // Find the target element
        const anchorLink = $(hash);
        if (anchorLink.length) {
            const headerHeight = 152;

            // Get the target offset
            const targetOffset = anchorLink.offset().top;

            // Verify we have a valid number
            if (typeof targetOffset === "number" && !isNaN(targetOffset)) {
                // Prevent default anchor behavior
                event?.preventDefault();

                // Scroll with timing adjustment
                setTimeout(() => {
                    window.scrollTo({
                        top: targetOffset - headerHeight,
                        behavior: "smooth"
                    });
                }, 100); // Small delay to ensure DOM is fully loaded
            } else {
                console.log('Invalid offset for element:', hash);
            }
        } else {
            console.log('Anchor not found:', hash);
        }
    });
});

$("#skip-to-content").on("click", function (e) {
	e.preventDefault();
	const offset = $("#main-content").offset();
	$("#ecu-skip-links").removeClass("active");
	$("html, body").animate(
		{ scrollTop: offset.top - $(".ecu-sticky").outerHeight() - 15 },
		"fast"
	);
	// move focus to main-content ID.
	$("#main-content").trigger("focus");
});

function getOffsetTop(elem) {
    var offsetTop = 0;

    do {
        if (!isNaN(elem.offsetTop)) {
            offsetTop += elem.offsetTop;
        }
    } while (
		(elem = elem.offsetParent)
	);

    return offsetTop;
}

// Internal page anchor links, offset header.
$("a[href^='#']").not("[href='#']").not("[href='#0']").on("click", function (e) {
    e.preventDefault();
	const $element = $(this);
    const url = $element.attr('href');
    const hash = $element.prop("hash").replace("#", "");
    const $target = $(`#${hash}`);

    if ($target.eq(0)) {
        let header = $("#main-nav").height() + $("#site-nav").height();
        window.scrollTo(0, getOffsetTop($target[0]) - header);
    } else {
        window.location.href = url;
    }
});

$("#theme-resources").on("hide.bs.collapse", function () {
    $("#toggle-resources").attr("aria-label", "Open Resource Menu");
    $("#resource-icon").addClass("fa-bars").removeClass("fa-close");
}).on("show.bs.collapse", function () {
    $("#toggle-resources").attr("aria-label", "Close Resource Menu");
    $("#resource-icon").addClass("fa-close").removeClass("fa-bars");

    setTimeout(function () {
        $("#search-input").focus();
    }, 500);
});

$(".drop-menu .skip-link").on("focus", function () {
    $("#ecu-skip-links").addClass("active");
}).on("blur", function () {
    $("#ecu-skip-links").removeClass("active");
});

$(document).on("keydown", function(e) {
    if (e.key === "Escape") {
		let $themeResources = $("#theme-resources");
		let $toggleResources = $("#toggle-resources");
		let $primaryNav = $("#primary-nav");
		let $ecuSkipLinks = $("#ecu-skip-links");

        if ($themeResources.hasClass("show")) {
            $themeResources.removeClass("show");
            $toggleResources.trigger("focus");
            $toggleResources.attr("aria-label", "Open Resource Menu");
            $("#resource-icon").addClass("fa-bars").removeClass("fa-close");
        } else if ($primaryNav.hasClass("show")) {
            $("#toggle-site-nav").trigger("focus");
            $primaryNav.removeClass("show");
        } else if ($ecuSkipLinks.hasClass("active")) {
            $ecuSkipLinks.removeClass("show");
            $("#main-nav a.navbar-brand").trigger("focus");
        }
    }
});

// Close resource menu when items do not have focus.
$.extend($.expr[':'], {
	focusable: function(el) {
		return $(el).is(':input, a, button');
	}
});

$(":focusable").on("focus", function() {
	let menu = $(document.activeElement).data("menu");

	if (menu !== "resources" && $("#theme-resources").hasClass("show")) {
		$("#toggle-resources").trigger("click");
	}
});
